import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { StsSelectors } from 'src/app/@store/selectors/sts.selectors';
import { SynlabHeaderService } from 'src/app/plasma-ui-common/synlab-access-ui-components/synlab-header/synlab-header.service';
import { AppRoutingModule } from "src/app/app-routing.module";
import { LayoutService } from '../layout.service';
import { HeaderSelectors } from 'src/app/@store/selectors/header.selectors';
import { HeaderActions } from 'src/app/@store/actions/header.actions';
import { RightSidebarComponent } from "../right-sidebar/right-sidebar.component";

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [AsyncPipe, AppRoutingModule, TranslocoModule, RightSidebarComponent],
  providers: [SynlabHeaderService],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit, OnDestroy {

  private readonly layoutService = inject(LayoutService);

  private readonly store = inject(Store);

  public userName: string;

  public currentLangCode: string;

  private readonly isUkDfp$ = this.store.select(StsSelectors.isDFPTenant);

  public readonly logo$ = this.isUkDfp$.pipe(map(isUkDfp => isUkDfp ? '/assets/img/ukdfplogo.png' : '/assets/img/synlab-logo.svg'));

  public readonly links$ = this.headerService.links$;

  public readonly showRightSidebar = this.layoutService.showRightSidebar;

  private readonly onDestroy$ = new Subject<void>();

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly headerService: SynlabHeaderService,
  ) { }

  ngOnInit(): void {
    this.trackCurrentLanguage();
    this.subscribeToUserInformation();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  private subscribeToUserInformation() {
    this.store
      .select(StsSelectors.getUserBasicInfo)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(({ givenName, familyName, synlabId }) => {
        if (!givenName || !familyName || !synlabId) return;

        this.userName = `${givenName} ${familyName[0]}.`;
      });
  }

  private trackCurrentLanguage() {
    this.currentLangCode = this.translocoService.getActiveLang();
    this.translocoService.langChanges$.pipe(takeUntil(this.onDestroy$)).subscribe((value) => {
      this.currentLangCode = value;
    });
  }

  public formatUrlWithLangCode(url: string | null) {
    if (!url) return url;

    const addQueryParam = (url, param, value) => {
      try {
        const urlObj = new URL(url);
        if (!urlObj.searchParams.has(param)) {
            urlObj.searchParams.append(param, value);
        }
        return urlObj.toString();
      } catch (error) {
        return url;
      }
    }

    return addQueryParam(url, 'langCode', this.currentLangCode);
  }
}
